import { ListPaginationMeta } from "utils/helpers/pagination";

export interface AddOrderSelectOption {
  value: string;
  labelKey?: string;
  label?: string;
}

export interface AddOrderForm {
  vehicleImage: string;
  vehicleImageName: string;
  customerName: string;
  subCustomer: string;
  chassis: string;
  manufacturer: string;
  model: string;
  axleConfiguration: string;
  year: string;
  boxType: string;
}

export enum AddOrderModalContext {
  QUOTE = "QUOTE",
  WORK_ORDER = "WORK_ORDER",
}

export type AddOrderDropDownKey = "customers" | "manufacturers" | "models";

export type AddOrderDropDownState = {
  items: string[];
  page: number;
  perPage: number;
  meta: ListPaginationMeta;
  loading: boolean;
  error: string | null;
};

export type AddOrderDropDowns = Record<
  AddOrderDropDownKey,
  AddOrderDropDownState
>;

export interface AddOrderModalState {
  isOpen: boolean;
  context: AddOrderModalContext;
  form: AddOrderForm;
  dropDowns: AddOrderDropDowns;
}
